import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';

export const Container = styled(Box)`
    display: flex;
    justify-content: center;
    // inner padding fot text under the steps + padding from figma design (todo: need to be refactored)
    padding-bottom: calc(24px + 36px);

    ${mediaQueries.tabletLandscape} {
        padding-bottom: calc(47px + 36px);
    }
`;

export const Line = styled.div<{ isFinished: boolean }>`
    width: 40px;
    height: 2px;

    @media (min-width: 768px) {
        width: 70px;
    }

    ${({ isFinished, theme }) => `background-color: ${isFinished ? theme['primary-default'] : theme['border-default']}`}
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
`;
